import React from "react";
import { useTranslation } from "react-i18next";
import gifIcon from "assets/ui-img/LoadingAnimation.gif";

export default function LocatingProvider(props) {
  const { t } = useTranslation();

  //function which presents loading gif to user
  return (
    <div
      className="text-center"
      style={{ paddingTop: "10%", paddingBottom: "30%", background: "white" }}
    >
      <h2>
        {props.disableAutoAccept
          ? t("description.AutoAcceptGifText1")
          : t("description.LocatingProviderGifText1")}
      </h2>
      <img className="mx-auto" src={gifIcon} alt="truck Gif" />
      <br />
      {props.disableAutoAccept && (
        <>
          {t("description.AutoAcceptGifText2")} <br />
          {t("description.AutoAcceptGifText3")}
        </>
      )}

      {(!props.isAutoAccept || !props.disableAutoAccept) &&
        t("description.LocatingProviderGifText2")}
    </div>
  );
}
